module.exports = __webpack_public_path__ + "static/media/header_instagram_icon.12469727.svg";